/**
 * @generated SignedSource<<ac4e67ff45a7147f3db0219d66449b21>>
 * @relayHash ab6c713571991d15a172cc151a881572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphQLContentStatus = "ARCHIVED" | "CURRENT" | "DELETED" | "DRAFT" | "%future added value";
export type useCommentQueryParamsCommentLocationQuery$variables = {
  commentId?: string | null | undefined;
  contentStatus?: ReadonlyArray<GraphQLContentStatus | null | undefined> | null | undefined;
};
export type useCommentQueryParamsCommentLocationQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly container: {
        readonly id: string | null | undefined;
      };
      readonly id: string;
      readonly location: {
        readonly __typename: string;
        readonly type: string;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useCommentQueryParamsCommentLocationQuery = {
  response: useCommentQueryParamsCommentLocationQuery$data;
  variables: useCommentQueryParamsCommentLocationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStatus"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "commentId"
      },
      {
        "kind": "Variable",
        "name": "contentStatus",
        "variableName": "contentStatus"
      }
    ],
    "concreteType": "PaginatedCommentList",
    "kind": "LinkedField",
    "name": "comments",
    "plural": false,
    "selections": [
      {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "ScalarField",
                "name": "type"
              }
            ]
          },
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCommentQueryParamsCommentLocationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCommentQueryParamsCommentLocationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ab6c713571991d15a172cc151a881572",
    "id": "f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae",
    "metadata": {},
    "name": "useCommentQueryParamsCommentLocationQuery",
    "operationKind": "query",
    "text": "query useCommentQueryParamsCommentLocationQuery($commentId:ID,$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId,contentStatus:$contentStatus){nodes{container{id},location{__typename,type},id}}}"
  }
};
})();

(node as any).hash = "60bed37eee2f8a7739db095067b4457b";

export default node;
